import { TableContainer as TableContainerUI } from '@mui/material'
import styled, { css } from 'styled-components'

interface Props {
  $even?: boolean
}

const TableContainer = styled(TableContainerUI)<Props>`
  background-color: #ffffff;
  border: 1px solid #efefef;
  border-radius: 3px;
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 5px;
  }
  table {
    min-width: 750px;
    tbody {
      > * {
        background-color: #ffffff;
      }
    }
  }
  ${(props) =>
    props.$even &&
    css`
      table {
        tbody {
          tr {
            > * {
              background: #ffffff;
            }
            &:nth-child(even) {
              > * {
                background: #f8f8f8;
              }
            }
            &:hover {
              > * {
                background: #e7ecec;
              }
            }
          }
        }
      }
    `}
`

export default TableContainer
